import React from 'react';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { BrowserRouter } from 'react-router-dom';
import theme from './theme/theme';
import PageLayout from './components/PageLayout';
import AppRoutes from './routes/AppRoutes';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <PageLayout>
          <AppRoutes />
        </PageLayout>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
